import React from 'react';
import ImgCursor from '@/shared/pictures/cursor.png';
export const Loading = () => {
  return <div className='loading'>
    <img className='loading_img' src={ImgCursor} alt="cursor" />
  </div>;
};
